var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "60px" } },
    [
      _c("template", { slot: "header" }, [_vm._v("Eliminar atención")]),
      _vm._v(" "),
      _c("div", { staticClass: "body" }, [
        _c("div", { staticClass: "student-attention" }, [
          _c("h3", [_vm._v("¿Deseas eliminar la atención definitivamente?")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-danger delete",
            class: { "is-loading": _vm.loading },
            on: { click: _vm.submit }
          },
          [_vm._v("\n      Eliminar\n    ")]
        ),
        _vm._v("\n     \n    "),
        _c(
          "button",
          {
            staticClass: "button is-primary is-outlined cancel",
            attrs: { disabled: _vm.loading },
            on: {
              click: function($event) {
                return _vm.navigateTo("app.profile.attentions")
              }
            }
          },
          [_vm._v("\n      Cancelar\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }